import { createPortal } from 'react-dom';
import { REACT_ROOT_MAIN } from '../../../constants/targets';
import ProductDisplayPage from './ProductDisplayPage';
import '@app/special-characters-support.scss';

const Container = () => {
  const pdpPortalTarget = document.getElementById(REACT_ROOT_MAIN);
  return pdpPortalTarget
    ? createPortal(<ProductDisplayPage />, pdpPortalTarget)
    : null;
};

export default Container;
